import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NotFound from "pages/NotFound";
import PRIVACY from "pages/privacy/privacy";
const V2Page = React.lazy(() => import("pages/landing"));
const ProjectRoutes = () => {
  return (
    <React.Suspense fallback={<>Loading...</>}>
      <Router>
        <Routes>
          <Route path="/" element={<V2Page />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/privacy" element={<PRIVACY />} />
        </Routes>
      </Router>
    </React.Suspense>
  );
};
export default ProjectRoutes;
